// ══════════════════════════════════════════════════════════════════════
//  Transformar lo tecleado SIN mandar el cursor al final.
//
//  Un campo que captura en mayusculas (nombres de identidad, folios, claves)
//  entrega en onChange un valor distinto del que el navegador tiene en el
//  campo: se tecleo "a" y el estado dice "A". React ve la diferencia y
//  reescribe `input.value`, y reescribir el valor de un campo manda el cursor
//  al final: corregir una palabra en medio del titulo obligaba a volver a
//  hacer clic en cada letra (2026-09-30, el titulo de PRE-193). Con Bloq Mayus
//  encendido el valor ya llega igual y no pasa nada, por eso aparecia y
//  desaparecia.
//
//  Aqui el campo se reescribe ANTES de que React lo vea, con el cursor donde
//  el usuario lo dejo (medido sobre lo transformado: un filtro que quita
//  caracteres lo recorre lo que quito antes del cursor). Cuando React compara,
//  el campo ya dice lo mismo que el estado y no lo toca.
//  Durante una composicion (IME, teclas muertas en algunos sistemas) no se
//  toca el campo: reescribirlo la cancelaria.
// ══════════════════════════════════════════════════════════════════════
import { mayusculasVivas } from '../../nombres.logic.js';

export function valorTransformado(e, transformar) {
  const el = e && e.target;
  if (!el) return transformar('');
  const crudo = el.value;
  const nuevo = transformar(crudo);
  if (nuevo === crudo || (e.nativeEvent && e.nativeEvent.isComposing)) return nuevo;
  let ini = null, fin = null;
  try { ini = el.selectionStart; fin = el.selectionEnd; } catch { /* tipo sin seleccion */ }
  el.value = nuevo;
  if (ini != null && fin != null) {
    const a = Math.min(transformar(crudo.slice(0, ini)).length, nuevo.length);
    const b = Math.min(transformar(crudo.slice(0, fin)).length, nuevo.length);
    try { el.setSelectionRange(a, b); } catch { /* tipo sin seleccion */ }
  }
  return nuevo;
}

const aMayusculas = (v) => mayusculasVivas(v);
export const valorEnMayusculas = (e) => valorTransformado(e, aMayusculas);
